import React, { useState } from "react";

const wishesData = [
  {
    title: "Children",
    icon: "👶",
    wishes: [
      "Good health, happiness, and safety",
      "Quality education and strong values",
      "Confidence, kindness, and respect for others",
      "Success in life without losing innocence",
      "A bright, secure future",
    ],
    needs: [
      "Time and energy to nurture them",
      "Support in their education (guidance, tuition, digital access)",
      "Balanced meals, healthcare, and emotional connection",
      "Freedom to teach and discipline with love",
      "Modern learning tools and safe digital spaces",
    ],
  },
  {
    title: "Husband",
    icon: "💑",
    wishes: [
      "Success in career or business",
      "Good health and peace of mind",
      "Understanding, respect, and partnership in marriage",
      "A happy, stress-free relationship",
      "Balance between work and family",
    ],
    needs: [
      "Emotional connection and appreciation",
      "Shared responsibilities at home",
      "Security (financial and emotional)",
      "Communication and time together",
      "Mutual growth — spiritual, emotional, and practical",
    ],
  },
  {
    title: "Parents",
    icon: "👵",
    wishes: [
      "Long, healthy, and peaceful life",
      "Dignity, comfort, and care in old age",
      "Pride and happiness in seeing their daughter happy",
      "Emotional closeness despite distance or marriage",
      "Family unity and blessings",
    ],
    needs: [
      "Ability to support them financially or emotionally",
      "Respect and inclusion from in-laws and husband",
      "Time to visit and care for them",
      "Health assistance and comfort at home",
      "Emotional peace knowing they’re safe",
    ],
  },
  {
    title: "Home",
    icon: "🏠",
    wishes: [
      "A peaceful, loving atmosphere",
      "Clean, organized, and beautiful surroundings",
      "Abundance — food, laughter, warmth",
      "Prosperity and positive energy",
      "A sense of belonging for everyone",
    ],
    needs: [
      "Safety and comfort",
      "Help in household chores or technology that saves time",
      "Financial stability",
      "A corner for herself — her dreams, rest, or creativity",
      "Emotional harmony among all members",
    ],
  },
  {
    title: "Herself",
    icon: "🌺",
    wishes: [
      "Recognition, respect, and self-worth",
      "Time for self-care and dreams",
      "Health, independence, and peace",
      "Love that sees her as an equal partner",
    ],
    needs: [
      "Emotional support system",
      "Financial literacy and independence",
      "Physical and mental well-being",
      "Learning opportunities — to grow personally and professionally",
    ],
  },
];

const SheEarnsWishes = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-black text-pink-400 p-2 font-sans md:font-serif">
      <div>
        <h1 className="text-xl md:text-2xl font-bold mb-2 text-center">
          🎁 SAKSHAM Shakti Wishes
        </h1>
        <button
          className="w-full text-white bg-pink-700 hover:bg-pink-500 text-center font-bold py-2 px-4 rounded-lg flex items-center justify-center gap-2 shadow-md hover:shadow-pink-400 transition-all duration-300 transform hover:scale-105"
        >
          ✨ Click to See SAKSHAM Shakti Tizori
        </button>
      </div>
      <div className="space-y-1">
        {wishesData.map((section, index) => (
          <div
            key={index}
            className="border border-pink-600 rounded-xl overflow-hidden shadow-lg hover:shadow-pink-500 transition-all duration-300"
          >
            <button
              onClick={() => toggleSection(index)}
              className="w-full flex justify-between items-center p-1 bg-pink-900 hover:bg-pink-800 text-left transition-colors duration-300 transform hover:scale-105"
            >
              <span className="text-m md:text-lg font-semibold flex items-center gap-2">
                {section.icon} {section.title}
              </span>
              <span className="text-lg md:text-xl transform transition-transform duration-300">
                {activeIndex === index ? "−" : "+"}
              </span>
            </button>

            <div
              className={`transition-max-height duration-500 overflow-hidden ${
                activeIndex === index ? "max-h-96 md:max-h-screen" : "max-h-0"
              }`}
            >
              {activeIndex === index && (
                <div className="p-2 bg-black text-pink-300 space-y-3 animate-fadeIn">
                  <div>
                    <h3 className="font-semibold text-pink-400 mb-1 flex items-center gap-2">
                      ✨ Wishes:
                    </h3>
                    <ul className="list-disc list-inside space-y-1 text-sm md:text-base">
                      {section.wishes.map((wish, i) => (
                        <li key={i}>{wish}</li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <h3 className="font-semibold text-pink-400 mb-1 flex items-center gap-2">
                      🛠️ Needs:
                    </h3>
                    <ul className="list-disc list-inside space-y-1 text-sm md:text-base">
                      {section.needs.map((need, i) => (
                        <li key={i}>{need}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SheEarnsWishes;
